import React, { useEffect, useState } from "react";
import {
    Box,
    AppBar,
    Toolbar,
    Typography,
    Grid2,
    Container,
    Link,
    useTheme,
    TextField,
    Button,
    ThemeProvider,
    createTheme,
    Divider,
    Autocomplete,
    FormHelperText,
} from "@mui/material";
import pwcLogo from "assets/Wrap.png";
import { useNavigate, useParams } from "react-router-dom";
import { useGetKeyIssueQuery, useUpdateWorkFlowMutation } from "store/slices/apis/keyIssueSlice";
import { Formik } from "formik";
import * as Yup from 'yup';
import { useDispatch } from "react-redux";
import { closeSnackbar, openSnackbar } from 'store/slices/snackbar';

const currentStatuses = [
    { label: "Open", year: 1994 },
    { label: "Close", year: 1972 }
];

const UpdateWorkFlowIssue = () => {
    const theme = useTheme();
    const { issueId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        'Status': '',
        ParentId: issueId,
        Comment: '',
        Type: 'issue'
    })
    const { data: keyIssue } = useGetKeyIssueQuery(issueId);
    const [updateWorkFlow, updateWorkFlowRes] = useUpdateWorkFlowMutation();

    const validationSchema = Yup.object({
        Status: Yup.string().required("Status field is required."),
        Comment: Yup.string().required("Comment field is required."),
    });

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 7000);

    };

    useEffect(() => {
        if (updateWorkFlowRes?.isSuccess) {
            if (updateWorkFlowRes?.data?.status == 'Success') {
                openNotification(updateWorkFlowRes?.data?.message, 'success')
                navigate('/issue/response', { replace: true })
            } else {
                openNotification(updateWorkFlowRes?.data?.message, 'error')
            }
        }

    }, [updateWorkFlowRes?.isSuccess]);

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        updateWorkFlow({ ...values, ParentId: keyIssue?.data?.id, data: JSON?.stringify(keyIssue?.data) })
        // resetForm();

    }
    const newTheme = createTheme({
        components: {

            MuiTextField: {
                styleOverrides: {
                    root: {
                        border: '2px solid #e6e6e6', '& .MuiFilledInput-input': {
                            backgroundColor: '#fff',
                            color: '#252525',
                            fontSize: '16px'
                        },
                        '& .MuiFilledInput-root::before': {
                            borderBottom: 'none'
                        },
                        '& .MuiFilledInput-root::after': {
                            borderBottom: `2px solid ${theme?.customSettings?.themeColor}`
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: '#696969',
                            fontSize: '14px'
                        },
                        '& .MuiFormLabel-root': {
                            fontSize: '15px'
                        },
                        '& .MuiFilledInput-root.Mui-disabled:before': {
                            borderBottom: 'none'
                        },
                        '& .MuiFilledInput-root': {
                            backgroundColor: '#fff'
                        },
                        '& .MuiFilledInput-input': {
                            backgroundColor: 'none',
                            fontSize: '14px'
                        },
                        '& .MuiInputLabel-root.Mui-disabled': {
                            color: '#696969'
                        },
                        '& .MuiFilledInput-root.Mui-disabled': {
                            backgroundColor: '#fff',
                            color: 'inherit'
                        },
                        '& .MuiFilledInput-input.Mui-disabled': {
                            WebkitTextFillColor: '#696969',
                            opacity: 'none'
                        }

                    },
                },
            }
        },
    });
    return (
        <ThemeProvider theme={newTheme}>
            <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                {/* Top App Bar */}
                <AppBar position="static" sx={{ backgroundColor: "#fff", boxShadow: "none" }}>
                    <Toolbar>
                        <img src={pwcLogo} style={{ width: "7%" }} alt="Logo" />
                    </Toolbar>
                </AppBar>

                <Grid2 container spacing={2} sx={{ flexGrow: 1, display: "flex", justifyContent: "center", backgroundColor: "#f3f3f3", p: 4 }}>
                    <Grid2 size={{ xs: 12, md: 8 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Issue Details
                        </Typography>
                        <Grid2 container spacing={2}>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Package"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.package}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Sub Package 1"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.subPackage1}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Sub Package 2"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.subPackage2}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Sub Package 3"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.subPackage3}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Sub Package 4"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.subPackage4}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Sub Package 5"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.subPackage5}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Sub Package 6"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.subPackage6}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Sub Package 7"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.subPackage7}
                                    disabled={true}
                                />
                            </Grid2>
                            <Divider sx={{ width: '100%' }} />
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Contractor"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.contactor_Name}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Action Required By"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.actionRequiredBy}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Action Required By Email"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.actionRequiredByEmail}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Current Status"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.currentStatus}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Time Impact"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.timeImpact}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    label="Cost Impact"
                                    variant="filled"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    value={keyIssue?.data?.costImpact}
                                    disabled={true}
                                />
                            </Grid2>
                            <Grid2 size={{ md: 6 }}>
                                <TextField
                                    id="outlined-multiline-static"
                                    label="Issue Description"
                                    name="issueDescription"
                                    multiline
                                    fullWidth
                                    rows={3}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    variant="filled"
                                    value={keyIssue?.data?.issueDescription}
                                    disabled={true}
                                />
                            </Grid2>
                        </Grid2>
                    </Grid2>

                    <Grid2 size={{ xs: 12, md: 4 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Comment
                        </Typography>
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize
                        >
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setTouched }) => (
                                <form onSubmit={handleSubmit}>
                                    <Grid2 container spacing={2}>

                                        <Grid2 size={12}>
                                            <Autocomplete
                                                options={currentStatuses}
                                                getOptionLabel={(option) => option?.label}
                                                value={currentStatuses.find((option) => option.label === values?.Status) || null}
                                                onChange={(_, newValue) => setFieldValue("Status", newValue ? newValue.label : "")}
                                                onBlur={() => setTouched({ ...touched, Status: true })}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Status"
                                                        name="Status"
                                                        slotProps={{ inputLabel: { shrink: true } }}
                                                        variant="filled"
                                                    />
                                                )}
                                                ListboxProps={{
                                                    sx: { fontSize: "13px" },
                                                }}
                                            />
                                            {touched?.Status && errors?.Status &&
                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.Status}`}</FormHelperText>
                                            }
                                        </Grid2>
                                        <Grid2 size={12}>
                                            <TextField
                                                id="outlined-multiline-static"
                                                label="Comment"
                                                name="Comment"
                                                multiline
                                                fullWidth
                                                rows={3}
                                                value={values?.Comment}
                                                onChange={handleChange}
                                                onBlur={() => setTouched({ ...touched, Comment: true })}
                                                slotProps={{ inputLabel: { shrink: true } }}
                                                variant="filled"
                                            />
                                            {touched?.Comment && errors?.Comment &&
                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.Comment}`}</FormHelperText>
                                            }
                                        </Grid2>

                                        <Grid2 size={12}>
                                            <Button type='submit' loading={updateWorkFlowRes?.isLoading} variant="contained" sx={{
                                                marginRight: '20px',
                                                backgroundColor: `${theme?.customSettings?.themeColor}`,
                                                color: '#FFF', padding: '6px 20px',
                                                fontWeight: '500', textTransform: 'none',
                                                float: 'right', fontSize: '16px'
                                            }}>
                                                Submit
                                            </Button>
                                        </Grid2>
                                    </Grid2>
                                </form>
                            )}
                        </Formik>
                    </Grid2>
                </Grid2>


                {/* Footer */}
                <Box sx={{ py: 2, backgroundColor: "#f5f5f5", textAlign: "center" }}>
                    <Container>
                        <Typography variant="caption" sx={{ color: "#252525", fontSize: "14px" }}>
                            Version: V1.2025 <br />
                            © 2025 PwC (RAD App Local). All rights reserved.
                        </Typography>
                        <Box sx={{ mt: 1 }}>
                            <Link href="#" color="inherit" sx={{ mx: 1, fontSize: "14px", fontWeight: "400", letterSpacing: "-0.2px" }}>
                                Legal Disclaimers
                            </Link>
                            |
                            <Link href="#" color="inherit" sx={{ mx: 1, fontSize: "14px", fontWeight: "400", letterSpacing: "-0.2px" }}>
                                Contact Support
                            </Link>
                            |
                            <Link href="#" color="inherit" sx={{ mx: 1, fontSize: "14px", fontWeight: "400", letterSpacing: "-0.2px" }}>
                                Click me!
                            </Link>
                        </Box>
                    </Container>
                </Box>
            </Box>
        </ThemeProvider >
    );
};

export default UpdateWorkFlowIssue;
